import { useState } from "react";
import * as Select from "@radix-ui/react-select";
import { Controller } from "react-hook-form";

import { tw } from "~/utils";
import { ChevronDownIcon } from "../icons/ChevronDownIcon";

interface SelectProps {
  name: string;
  control: any;
  options: { value: string; label: string }[];
  placeholder?: string;
  /** Called after the field value updates, e.g. to auto-advance the step. */
  onValueChange?: (value: string) => void;
}

export const Dropdown = ({
  name,
  control,
  options,
  placeholder = "Select an option",
  onValueChange,
}: SelectProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Select.Root
          value={field.value}
          onValueChange={(value) => {
            field.onChange(value);
            setIsOpen(false);
            onValueChange?.(value);
          }}
        >
          <Select.Trigger
            className={tw(
              "flex w-full cursor-pointer items-center justify-between rounded-lg border border-gray-300 bg-white px-4 py-3 text-left",
              !field.value && "text-gray-400",
            )}
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <Select.Value placeholder={placeholder} />
            <ChevronDownIcon
              className={`ml-2 transition-transform ${isOpen ? "rotate-180" : ""}`}
            />
          </Select.Trigger>
          <Select.Content className="absolute z-10 w-full cursor-pointer rounded-lg border border-gray-300 bg-white shadow-lg">
            <Select.ScrollUpButton />
            <Select.Viewport>
              {options.map((option) => (
                <Select.Item
                  className="px-4 py-3 hover:bg-blue-100 hover:text-blue-500"
                  key={option.value}
                  value={option.value}
                >
                  <Select.ItemText>{option.label}</Select.ItemText>
                </Select.Item>
              ))}
            </Select.Viewport>
            <Select.ScrollDownButton />
          </Select.Content>
        </Select.Root>
      )}
    />
  );
};
